import React from 'react';
import { Link } from 'react-router-dom';
import pic from "../logo.png"
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap';

const Header = () => {
    return (
        <Navbar className='navBar' expand="lg">
            <Container>
                <Navbar.Brand href="/">
                    <img id="header-logo" src={pic} />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link as={Link} className="nav-links nav-link" to="/">Home</Nav.Link>
                        <Nav.Link as={Link} className="nav-links nav-link" to="/planning">Planning</Nav.Link>
                        <NavDropdown className="nav-links" title="My Stuff" id="basic-nav-dropdown">
                            <NavDropdown.Item as={Link} className="nav-links-dropdown dropdown-item" to="/myrecipes">Recipes</NavDropdown.Item>
                            <NavDropdown.Item as={Link} className="nav-links-dropdown dropdown-item" to="/mylist">Shopping List</NavDropdown.Item>
                            <NavDropdown.Item as={Link} className="nav-links-dropdown dropdown-item" to="/mypantry">Pantry</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item as={Link} className="nav-links-dropdown dropdown-item" to="/addrecipe">Add A Recipe</NavDropdown.Item>
                            {/* <Link className="nav-links-dropdown dropdown-item" to="/importrecipe">Import Recipe from URL</Link> */}
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Header;
